import { render } from "./MyRead.vue?vue&type=template&id=6c4b50d2&scoped=true"
import script from "./MyRead.vue?vue&type=script&lang=js"
export * from "./MyRead.vue?vue&type=script&lang=js"

import "./MyRead.vue?vue&type=style&index=0&id=6c4b50d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4b50d2"]])

export default __exports__